import * as React from "react";
import axios from "axios";
import auth from "../../../../Auth";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlusCircle } from "@fortawesome/free-solid-svg-icons";
import ColumnMenu from "../../../../Shared/GridComponents/ColumnMenu";
import { CellRender, GridNoRecord, ManageCandidateStatusCell, StatusCell } from "../../../../Shared/GridComponents/CommonComponents";
import { Grid, GridColumn, GridNoRecords } from "@progress/kendo-react-grid";
import CompleteSearch from "../../../../Shared/Search/CompleteSearch";
import { State, toODataString } from "@progress/kendo-data-query";
import { CustomMenu, DetailColumnCell, DefaultActions, ViewMoreComponent } from "./GlobalActions";
import ConfirmationModal from "../../../../Shared/ConfirmationModal";
import RowActions from "../../../../Shared/Workflow/RowActions";
import { downloadExcel, errorToastr, initialDataState, successToastr } from "../../../../../HelperMethods";
import { hideLoader, KendoFilter, NumberCell, PhoneNumberCell, showLoader } from "../../../../ReusableComponents";
import { AppPermissions } from "../../../../Shared/Constants/AppPermissions";
import { CANDIDATE_REMOVE_SUCCESS_MSG, EXCEL_DOWNLOAD_INPROGRESS, REMOVE_CANDIDATE_CONFIRMATION_MSG } from "../../../../Shared/AppMessages";
import { AuthRoleType, PageId, PageName } from "../../../../Shared/AppConstants";
import BreadCrumbs from "../../../../Shared/BreadCrumbs/BreadCrumbs";
import globalAdminService from "../../Service/DataService";
import { Dialog } from "@progress/kendo-react-dialogs";
import DoNotHire from "../DoNotHire/DoNotHire";
import CandidateShareWF from "../../CandidateShareWF/CandidateShareWF";
import Collapsible from "react-collapsible";

export interface CandidatesProps {

}

export interface CandidatesState {
    data: any;
    onFirstLoad: boolean;
    totalCount?: number;
    showLoader?: boolean;
    showAddNewCandidateModal?: any;
    showEditModal?: boolean;
    showRemoveModal?: boolean;
    showDeleteModal?: boolean;
    showInviteCandidateModal?: boolean;
    dataState: any;
    vendorId?: string;
    showDoNotRehireModal: boolean;
    showEditDoNotRehireModal: boolean;
    toggleFirst: boolean;
}

class Candidates extends React.Component<CandidatesProps, CandidatesState> {
    private userObj: any = JSON.parse(localStorage.getItem("user"));
    public candId: string;
    public dataItem: any;
    public openModal: any;
    constructor(props: CandidatesProps) {
        super(props);
        this.state = {
            data: [],
            dataState: initialDataState,
            onFirstLoad: true,
            showLoader: true,
            vendorId: auth.getVendor(),
            showDoNotRehireModal: false,
            showEditDoNotRehireModal:false,
            toggleFirst: true,
        };
    }

    getCandidates = (dataState) => {
        this.setState({ showLoader: true, onFirstLoad: false });
        var queryStr = `${toODataString(dataState)}`;
        var finalQueryString = queryStr;
        var queryParams = '';
        if (this.state.vendorId) {
            queryParams = `contains(vendors,'${this.state.vendorId}')`;
            finalQueryString = KendoFilter(dataState, queryStr, queryParams);
        }
        if (dataState?.filter === null || dataState?.filter === undefined || dataState?.filter.filters.length === 0) {
            this.setState({
                data: [],
                showLoader: false,
                totalCount: 0
            });
        } else {
            axios.get(`api/candidates/manage?${`$count=true&`}${finalQueryString}`).then((res) => {
                this.setState({
                    data: res.data.items,
                    showLoader: false,
                    dataState: dataState,
                    totalCount: res.data.count
                });
            });
        }
    }

    downloadCandidateExcel = () => {
        if (this.state.data.length === 0) {
            return;
        }
        var finalState: State = {
            ...this.state.dataState,
            take: null,
            skip: 0,
        };
        var queryStr = `${toODataString(finalState)}`;
        var finalQueryString = queryStr;
        var queryParams = '';
        if (this.state.vendorId) {
            queryParams = `contains(vendors,'${this.state.vendorId}')`;
            finalQueryString = KendoFilter(this.state.dataState, queryStr, queryParams);
        }
        successToastr(EXCEL_DOWNLOAD_INPROGRESS);
        globalAdminService.getCandidateExcel(finalQueryString).then((res: any) => {
            if (res) {
                downloadExcel("Talent Pool.xlsx", res.data);
            }
        });
    }

    deleteCandidate = (id) => {
        this.setState({ showDeleteModal: false, showRemoveModal: false });
        axios.delete(`/api/candidates/${id}`).then((res) => {
            successToastr(CANDIDATE_REMOVE_SUCCESS_MSG);
            this.getCandidates(this.state.dataState);
        });
    };

    expandChange = (dataItem) => {
        const { data } = this.state;
        const candidateData = data.map((item) => {
          if (item === dataItem) {
            item.expanded = !item.expanded;
          }
          return item;
        });
        this.setState({
            data: candidateData
        });
    };

    onDataStateChange = (changeEvent) => {
        this.getCandidates(changeEvent.dataState);
        localStorage.setItem("ManageCandidate-GridDataState", JSON.stringify(changeEvent.dataState));
    };

    ExpandCell = (props) => <DetailColumnCell {...props} expandChange={this.expandChange.bind(this)} />;

    handleActionClick = (action, actionId, rowId, nextStateId?, eventName?, dataItem?) => {
        let change = {};
        let property = `show${action.replace(/ +/g, "").replace(".", "")}Modal`;
        change[property] = true;
        this.setState(change);
        this.dataItem = dataItem;
    }

    inviteCandidate = (data) => {
        this.setState({ showInviteCandidateModal: false });
        if (data.userId) {
            showLoader();
            axios.get(`/api/accounts/invite/${data.userId}`)
                .then(res => {
                    hideLoader();
                    successToastr("Invitation Sent");
                })
        } else {
            let userData = {
                userId: data.userId,
                userType: AuthRoleType.Provider,
                lastName: data.lastName,
                firstName: data.firstName,
                roleId: data.roleId,
                candidateId: data.id,
                address: {
                    addressId: data.addressId,
                    email: data.email,
                    addressLine1: data.address1,
                    addressLine2: data.address2,
                    contactNum1: data.mobileNumber.replace(/\D+/g, ""),
                    contactNum2: data.phoneNumber ? data.phoneNumber.replace(/\D+/g, "") : "",
                    pinCodeId: data.postalCode,
                    cityId: data.cityId,
                    stateId: data.stateId,
                    countryId: data.countryId,

                },
                sendInvite: true
            };
            axios.post("api/users", JSON.stringify(userData)).then((res:any) => {
                if (res.data.succeeded) {
                    successToastr("Invitation sent successfully");
                } else {
                    errorToastr(res.data.errors[0]);
                }
            });
        }
    }

    openCollapsible = () => {
        this.setState({ toggleFirst: true });
    };

    closeCollapsible = () => {
        this.setState({ toggleFirst: false });
    };

    render() {
        return (
            <div className="col-11 mx-auto pl-0 pr-0 mt-3  mt-md-0">
                <div className="container-fluid mt-3 mb-3 d-md-block d-none">
                    <div className="row pt-2 pb-2 mt-3 accordianTitleClr mx-auto mb-2">
                        <div className="col-10 fonFifteen paddingLeftandRight">
                            <BreadCrumbs ></BreadCrumbs>
                        </div>
                        <div className="col-2">
                            {auth.hasPermissionV2(AppPermissions.CANDIDATE_CREATE) && (
                                <Link to="/candidate/create">
                                    <span className="float-right text-dark">
                                        <FontAwesomeIcon icon={faPlusCircle} className={"mr-1 text-dark"} />
                                        Add New Candidate
                                    </span>
                                </Link>
                            )}
                        </div>
                    </div>
                </div>

                <div className="container-fluid pb-3">
                    <CompleteSearch
                        entityType={"Candidate"}
                        placeholder="Search text here!"
                        handleSearch={this.getCandidates}
                        onFirstLoad={this.state.onFirstLoad}
                        persistSearchData={true}
                        page={PageName.ManageCandidate}
                        pageId={PageId.ManageCandidate}
                    />
                    <div className="manageCandidateContainer table_responsive table_responsive-TABcandidates">
                        <Grid
                            style={{ height: "auto" }}
                            sortable={true}
                            onDataStateChange={this.onDataStateChange}
                            pageable={{ pageSizes: true }}
                            data={this.state.data}
                            {...this.state.dataState}
                            detail={ViewMoreComponent}
                            expandField="expanded"
                            total={this.state.totalCount}
                            className="kendo-grid-custom k-widget lastchild"
                        >
                            <GridNoRecords>{GridNoRecord(this.state.showLoader, null, true)}</GridNoRecords>

                            <GridColumn
                                field="lastName"
                                title="Last Name"
                                cell={(props) => CellRender(props, "Last Name")}
                                columnMenu={ColumnMenu}
                                filter="text"
                            />
                            <GridColumn
                                field="firstName"
                                title="First Name"
                                columnMenu={ColumnMenu}
                                cell={(props) => CellRender(props, "First Name")}
                                filter="text"
                            />
                            <GridColumn
                                field="position"
                                title="Position"
                                columnMenu={ColumnMenu}
                                cell={(props) => CellRender(props, "Position")}
                            />
                            <GridColumn
                                field="npi"
                                width="130px"
                                title="NPI#"
                                columnMenu={ColumnMenu}
                                cell={(props) => CellRender(props, "NPI#")}
                            />
                            <GridColumn
                                field="mobileNumber"
                                width="130px"
                                title="Mobile Number"
                                sortable={false}
                                filterable={false}
                                cell={(props) => PhoneNumberCell(props, "Mobile Number")}
                            />
                            <GridColumn
                                field="email"

                                title="Email"
                                columnMenu={ColumnMenu}
                                cell={(props) => CellRender(props, "Email")}
                            />
                            <GridColumn
                                field="candidateType"
                                width="150px"
                                title="Candidate Type"
                                columnMenu={ColumnMenu}
                                cell={(props) => CellRender(props, "Candidate Type")}
                            />
                            <GridColumn
                                field="status"
                                width="200px"
                                title="Status"
                                columnMenu={ColumnMenu}
                                cell={ManageCandidateStatusCell}
                            />
                            <GridColumn
                                title="Action"
                                sortable={false}
                                width="50px"
                                headerClassName="tab-action"
                                cell={(props) => (
                                    <RowActions
                                        dataItem={props.dataItem}
                                        currentState={""}
                                        rowId={props.dataItem.candId}
                                        handleClick={this.handleActionClick}
                                        defaultActions={DefaultActions(props, this.state.vendorId)}
                                    />
                                )}
                                headerCell={() => CustomMenu(this.downloadCandidateExcel)}
                            />
                            <GridColumn sortable={false} field="expanded"
                                width="100px" title="View More" cell={this.ExpandCell} />
                        </Grid>
                    </div>
                </div>

                <div className="container-fluid mt-3">
                    {auth.hasPermissionV2(AppPermissions.CAND_SHARE_TALENT_POOL_VIEW) && (
                            <div className="row mx-0 rel-notuse mb-3">
                                <Collapsible
                                    trigger="Candidate Share Requests"
                                    open={this.state.toggleFirst}
                                    accordionPosition="1"
                                    onTriggerOpening={() => this.setState({ toggleFirst: true })}
                                    onTriggerClosing={() => this.setState({ toggleFirst: false })}
                                >
                                    <div className="col-12 mt-2 z-index px-0">
                                        <CandidateShareWF
                                            isChildGrid = {true}
                                        />
                                    </div>
                                </Collapsible>
                            </div>
                        )}
                </div>

                <ConfirmationModal
                    message={"Are you sure you want to invite candidate?"}
                    showModal={this.state.showInviteCandidateModal}
                    handleYes={() => this.inviteCandidate(this.dataItem)}
                    handleNo={() => {
                        this.setState({ showInviteCandidateModal: false });
                    }}
                />

                <ConfirmationModal
                    message={REMOVE_CANDIDATE_CONFIRMATION_MSG()}
                    showModal={this.state.showRemoveModal}
                    handleYes={() => this.deleteCandidate(this.dataItem.id)}
                    handleNo={() => {
                        this.setState({ showRemoveModal: false });
                    }}
                />
                {this.state.showDoNotRehireModal && (
                    <div id="Edit-division">
                        <Dialog className="col-12 For-all-responsive-height">
                            <DoNotHire
                                props={this.dataItem}
                                onCloseModal={() => this.setState({ showDoNotRehireModal: false }, () => { this.getCandidates(this.state.dataState); })}
                                onOpenModal={() => this.setState({ showDoNotRehireModal: false })}
                               
                            />
                        </Dialog>
                    </div>
                )}
                {this.state.showEditDoNotRehireModal && (
                    <div id="Edit-division">
                        <Dialog className="col-12 For-all-responsive-height">
                            <DoNotHire
                                props={this.dataItem}
                                onCloseModal={() => this.setState({ showEditDoNotRehireModal: false }, () => { this.getCandidates(this.state.dataState); })}
                                onOpenModal={() => this.setState({ showEditDoNotRehireModal: false })}

                            />
                        </Dialog>
                    </div>
                )}
            </div>
        );
    }
}
export default Candidates;

